import { render, staticRenderFns } from "./nav-side.vue?vue&type=template&id=48a2e32c"
import script from "./nav-side.vue?vue&type=script&lang=js"
export * from "./nav-side.vue?vue&type=script&lang=js"
import style0 from "./nav-side.vue?vue&type=style&index=0&id=48a2e32c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports